import { Button, Card, Col, Row, Spin, Tooltip, Typography, message } from "antd";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { AppContext } from "../context/AppContext";
import useHttp from "../hooks/useHttp";
import "./../assets/css/application-logos.css";
import { SecondaryConfirmationModal } from "../pages/utils/CommonNotifications";

const { Text } = Typography;
const LoginAppsPage = () => {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedService, setSelectedService] = useState();
  const [installationUrl, setInstallationUrl] = useState();
  const [openNotification, setOpenNotification] = useState();
  const { fetchData } = useHttp();
  const [appProperties, setAppProperties] = useContext(AppContext);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [appLogoName, setAppLogoName] = useState();
  const [spinButton, setSpinButton] = useState(false);
  const [serviceConfigurationLoading, setServiceConfigurationLoading] = useState(false);
  const MODAL_TYPES = {
    CONFIRMATION: "CONFIRMATION",
  };

  const MODAL_CONFIGS = {
    [MODAL_TYPES.CONFIRMATION]: {
      title: "Connecting Your " + selectedService,
      message: "You'll now be redirected to the authorization and installation page to complete setup.",
      secondaryMessage: "Click Continue to proceed.",
      confirmText: "Continue",
    },
  };

  useEffect(() => {
    if (appProperties && appProperties?.setLoading) {
      appProperties?.setLoading(false);
      setAppProperties((prev) => {
        return {
          ...prev,
          websiteLogin: true,
        };
      });
    }
  }, [appProperties?.setLoading]);
  useEffect(() => {
    console.log("openNotification >>>>>>>>>>>>>>>", openNotification);
    if (openNotification !== undefined) {
      setSpinButton(false);
      setShowConfirmationModal(true);
    }
  }, [openNotification]);

  const handleLogout = useCallback(() => {
    fetchData(`website/logout`, "DELETE", null, appProperties).then(function (response) {
      if (typeof response === "string") {
        response = JSON.parse(response);
      }
      if (response?.data?.isValid) {
        window.location.href = "/web/signin";
      }
    });
  }, [fetchData, appProperties]);

  const createStandAloneApp = useCallback(() => {
    setServiceConfigurationLoading(true);
    fetchData(`website/create/account`, "POST", null, appProperties)
      .then(function (response) {
        if (typeof response === "string") {
          response = JSON.parse(response);
        }
        console.log("createStandAloneApp response:", response);
        if (response?.data?.urlToBeRedirected) {
          window.open(response?.data?.urlToBeRedirected, "_self");
          setShowConfirmationModal(false);
        }
      })
      .finally(() => {
        setServiceConfigurationLoading(false);
      });
  }, [fetchData, appProperties]);

  useEffect(() => {
    const fetchUserApps = async () => {
      try {
        // Replace with your actual API endpoint
        console.log("appProperties >>>>>>>>>>>>>>>", appProperties.websiteLogin);
        fetchData("website/apps/all", "GET", null, appProperties).then(function (response) {
          if (typeof response === "string") {
            response = JSON.parse(response);
          }
          if (response) {
            console.log("all apps:", response);
            if (response?.data?.apps) {
              const sortedApps = (response?.data?.apps || []).slice().sort((a, b) => (a.appDisplayOrder ?? 0) - (b.appDisplayOrder ?? 0));
              setApps(sortedApps);
            }
            let defaultApp = response?.data?.apps?.find((app) => app.defaultApp);
            setSelectedService(defaultApp?.appName || null);
            setInstallationUrl(defaultApp?.installationUrl || null);
          } else {
            window.open("/web/signin", "_self");
          }
        });
      } catch (error) {
        console.error("Error fetching apps:", error);
        message.error("Failed to load apps. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
    if (appProperties?.websiteLogin) {
      fetchUserApps();
    }
  }, [appProperties?.websiteLogin]);

  return (
    <>
      <div className="hs-bg-off-white">
        <Col>
          <Row>
            <Col span={12}>
              <div className="d-flex justify-content-left ps-4">
                <div className="ant-col mt-3 css-3rel02">
                  <div className="static-icon-for-logo sideBar-hellosend-logo" title=""></div>
                </div>
                <div className="ant-col mt-3 pt ms-1 css-3rel02">
                  <div
                    style={{
                      textTransform: "capitalize",
                      color: "#111827",
                      fontWeight: 700,
                      fontSize: 18,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      marginTop: "10px",
                    }}
                  >
                    HelloSend
                  </div>
                </div>
              </div>
            </Col>
            <Col span={12} className="d-flex justify-content-end align-items-center pe-5 cursor-pointer">
              <div className="d-flex flex-row justify-content-end align-items-center" onClick={handleLogout}>
                <div className="actionIconsSprite logout-icon-website mb-2" style={{ fontSize: 10 }}></div>
                <div className="hs-fs-14 hs-color-violet">Try with different email </div>
              </div>
            </Col>
          </Row>
          <Row>
            <div className="d-flex flex-column justify-content-center align-items-center w-100 h-100">
              <div className="d-flex flex-column justify-content-center align-items-middle hs-w-85 h-100 px-5">
                <Row gutter={[24, 24]} className="d-flex  justify-content-center w-100 py-3">
                  <Col span={24} className="d-flex justify-content-center align-items-center w-100">
                    <Text type="primary" className="hs-fw-bolder hs-fs-25" style={{ textAlign: "center" }}>
                      Seamless Customer Communication
                    </Text>
                  </Col>
                </Row>

                {loading ? (
                  <div style={{ textAlign: "center", margin: "50px 0" }}>
                    <Spin size="large" />
                  </div>
                ) : (
                  <>
                    <Row gutter={[16, 16]} justify="start" align="middle" className="w-100 d-flex justify-content-center h-100">
                      <>
                        <Col span={24} className="w-100 d-flex justify-content-center">
                          <div style={{ textAlign: "center" }} className="d-flex justify-content-center hs-w-75">
                            <p>
                              Deliver smooth, unified conversations through SMS, WhatsApp, and Calls—integrated with your tools or used as a
                              standalone platform. Built for teams that put customers first.
                            </p>
                          </div>
                        </Col>
                        <Col span={24} className="w-100 py-3">
                          <div className="d-flex flex-row justify-content-start align-items-center w-100 h-100 supported-apps-container">
                            <Row gutter={[16, 16]} justify="start" align="middle" style={{ width: "100%" }}>
                              {apps.length > 0 &&
                                apps.map((app, index) =>
                                  app?.leftServiceId ? (
                                    <Col key={index} xs={24} sm={12} md={8} lg={6}>
                                      <Card
                                        title={
                                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <div className={"applicationLogosSprite " + app.appLogoName}></div>
                                          </div>
                                        }
                                        hoverable
                                        onClick={() => {
                                          setSelectedService(app.appName);
                                          setInstallationUrl(app?.installationUrl);
                                          setAppLogoName(app.appLogoName);
                                          if (app.appName === "HelloSend") {
                                            createStandAloneApp();
                                          } else {
                                            setOpenNotification(!openNotification);
                                          }
                                        }}
                                        className={`${
                                          serviceConfigurationLoading ? "pe-none opacity-50" : ""
                                        } ant-card-applications service-card-normal ${
                                          selectedService === app.appName ? " service-card-selectedd" : ""
                                        }`}
                                      >
                                        <>
                                          <div style={{ fontWeight: "bold", fontSize: 14 }}>
                                            {app.appName === "HelloSend" ? "Standalone Mode" : app.appName}
                                          </div>
                                          <Tooltip title={app.appDescription}>
                                            <Typography.Paragraph style={{ marginBottom: 0 }}>
                                              <div
                                                style={{
                                                  fontSize: 12,
                                                  color: "#555",
                                                  marginTop: 12,
                                                  height: 72, // 4 lines
                                                  lineHeight: "18px",
                                                  overflow: "hidden",
                                                  display: "-webkit-box",
                                                  WebkitLineClamp: 4,
                                                  WebkitBoxOrient: "vertical",
                                                }}
                                              >
                                                {app.appDescription}
                                              </div>
                                            </Typography.Paragraph>
                                          </Tooltip>
                                        </>
                                        <Button type="link" className="hs-color-violet ps-0 ms-0 hs-fs-14 hs-fw-600 app-integration-button">
                                          {app.appName === "HelloSend" ? "Get started" : "Integrate"}
                                        </Button>
                                      </Card>
                                    </Col>
                                  ) : null
                                )}
                            </Row>
                          </div>
                        </Col>
                      </>
                    </Row>
                  </>
                )}
              </div>
            </div>
          </Row>
        </Col>
      </div>
      {showConfirmationModal && (
        <SecondaryConfirmationModal
          isOpen={showConfirmationModal}
          type={MODAL_TYPES.CONFIRMATION}
          modalConfigs={MODAL_CONFIGS}
          onClose={() => setShowConfirmationModal(false)}
          defaultModalIcon={"applicationLogosSprite " + appLogoName}
          spinButton={spinButton}
          onConfirm={() => {
            setSpinButton(true);
            setOpenNotification(false);
            if (!selectedService) return message.error("Please select a service");
            if (installationUrl) {
              window.open(installationUrl, "_self");
            } else if (selectedService === "HelloSend") {
              createStandAloneApp();
            }
          }}
        />
      )}
    </>
  );
};

export default LoginAppsPage;
